import { useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import { reviewOutputAtom } from '../atoms';
import type { ReviewOutputDataT } from '../types';
type Props = {
  onReviewStateChange: (reviewOutput: ReviewOutputDataT) => void;
};
export const useReviewOutput = ({
  onReviewStateChange
}: Props) => {
  const reviewOutput = useAtomValue(reviewOutputAtom);
  const onReviewStateChangeRef = useRef(onReviewStateChange);
  // eslint-disable-next-line react-hooks/refs
  onReviewStateChangeRef.current = onReviewStateChange;
  useEffect(() => {
    onReviewStateChangeRef.current(reviewOutput);
  }, [reviewOutput]);
  return reviewOutput;
};